export * from './format'

export const isProd = import.meta.env.VITE_NETWORK === 'prod'
export function getImageUrl(name: string): string {
  if (!name)
    return ''

  if (name.startsWith('http'))
    return name

  try {
    const modules = import.meta.glob<string>('../assets/img/**/*', {
      eager: true,
      import: 'default',
    })

    const path = `../assets/img/${name}`
    const normalizedPath = Object.keys(modules).find(
      key => key.toLowerCase() === path.toLowerCase(),
    )

    return normalizedPath ? modules[normalizedPath] : ''
  }
  catch (error) {
    console.error(`Error loading image: ${name}`, error)
    return ''
  }
}

/**
 * 拿缓存数据
 * @param {string} key
 */
export function getStorage(key: string) {
  if (localStorage.getItem(key)) {
    return JSON.parse(localStorage.getItem(key) || '')
  }
  return ''
}

/**
 * 设置缓存数据
 * @param {string} key
 * @param {all} val
 */
export function setStorage(key: string, val: any) {
  return localStorage.setItem(key, JSON.stringify(val))
}
/**
 * 移除缓存数据
 * @param {string} key
 */
export function removeStorage(key: string) {
  return localStorage.removeItem(key)
}

// 格式化0x9a762214559cb343f827f85511b856ea0ac99782 为 0x9a76...9782
export function getAccountAddress(address?: string): string {
  if (!address) {
    return ''
  }

  return `${address.slice(0, 6)}...${address.slice(-6)}`
}

export function getTxTypeStr(type: string) {
  if (type === 'stake') {
    return 'Stake'
  }
  if (type === 'instantUnstake') {
    return 'Instant Unstaking'
  }
  if (type === 'bridge') {
    return 'Bridge'
  }
  if (type === 'unstake') {
    return 'Standard Unstaking'
  }
  if (type === 'withdraw') {
    return 'Standard Unstaking'
  }
  return ''
}

export function compareAddress(a?: string, b?: string) {
  if (!a || !b) {
    return false
  }
  return a.toLowerCase() === b.toLowerCase()
}
